<div class="notifier {{data.type}}">
  <div class="title">
    <i [class]="'uil uil-' + icon"></i>
    {{ data.title }}
  </div>
  <div class="message" [innerHTML]="data.message"></div>
</div>
